export default "__VITE_ASSET__DWr_rjya__"